<template>
  <div class="col col-8">
    <div class="tables-container">
      <div class="head-container">
        <h1 class="h3">
          {{ currentTable.headers[0] }}
        </h1>
        <h4 v-if="currentTable.headers[1]">
          {{ currentTable.headers[1] }}
        </h4>
        <p class="description" :class="{ 'fd-table': $route.params.id === 'f-distribution-table' }">
          {{ currentTable.description }}
        </p>

        <p v-if="$route.params.id === 'f-distribution-table'" class="dropdown-label">
          Significance Level (α):
        </p>
        <Dropdown
          v-if="$route.params.id === 'f-distribution-table'"
          calculator
          class="small-dropdown"
          :selected="selectedAlpha"
          :radio-buttons="{ first: '0.005', second: '0.01', third: '0.025', fourth: '0.05' }"
          @change="currentSelectedAlpha"
        />
      </div>

      <div
        class="wrapper"
        :class="{ gradient: currentTable.gradient,
                  'no-gradient-after': endScrolledAfter, 'no-gradient-before': endScrolledBefore }"
      >
        <div
          class="table-wrapper"
          :class="{ 'bigger-tables': currentTable.gradient,
                    'std-table': $route.params.id === 'students-t-distribution-table' }"
          @scroll="handleScroll"
        >
          <div :class="{ 'bigger-tables-wrapper': currentTable.gradient }">
            <table>
              <tr>
                <th v-for="(num, i) in currentTable.columnHeaders" :key="i">
                  <p v-html="num" />
                </th>
              </tr>
              <tr v-for="(row, i) in currentTable.values" :key="i" :class="`tr-${i}`">
                <td :class="{ 'padding-right': currentTable.rowHeaders[i] === 'df2:1' }">
                  {{ currentTable.rowHeaders[i] }}
                </td>
                <td
                  v-for="(num, y) in row" :key="y" :class="`td-${y}`"
                  @mouseover="hover($event, i, y)" @mouseleave="removeHover($event)"
                >
                  <p>
                    {{ num.toFixed(currentTable.decimalPlaces) }}
                  </p>
                </td>
              </tr>
              <tr
                v-if="currentTable.columnFooters"
              >
                <th v-for="(str, i) in currentTable.columnFooters" :key="i">
                  {{ str }}
                </th>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <p v-if="$route.params.id === 'students-t-distribution-table'" class="cl-info">
        {{ currentTable.footnote }}
      </p>
    </div>
  </div>
</template>

<script>
import Dropdown from '@itbpbg/lms-components/src/components/Dropdown.vue';
import { TABLES as tables } from '../../../../utils/calculators';

export default {
  components: {
    Dropdown,
  },
  data() {
    return {
      currentTable: {},
      selectedAlpha: 'first',
      endScrolledAfter: false,
      endScrolledBefore: true,
    };
  },
  created() {
    const kebabToCamel = (str) => str.replace(/-([a-z])/g, (match, p1) => p1.toUpperCase());
    this.currentTable = { ...tables[kebabToCamel(this.$route.params.id)] };

    if (this.$route.params.id === 'f-distribution-table') {
      this.currentTable.values = this.currentTable.values.first;
    }
  },
  methods: {
    handleScroll(event) {
      const { scrollLeft, scrollWidth, offsetWidth } = event.target;
      const contentWidth = scrollWidth - offsetWidth;
      if (contentWidth <= scrollLeft + 10) {
        this.endScrolledAfter = true;
      } else {
        this.endScrolledAfter = false;
      }

      if (scrollLeft - 10 >= 0) {
        this.endScrolledBefore = false;
      } else {
        this.endScrolledBefore = true;
      }
    },
    hover($event, trIndex, tdIndex) {
      // color previous td-s from other rows
      const allTrs = Array.from(document.querySelectorAll('table tr'));
      const previousTrs = allTrs.slice(1, allTrs.findIndex((tr) => tr.classList.contains(`tr-${trIndex}`)));
      previousTrs.forEach((tr) => {
        tr.querySelector(`.td-${tdIndex}`).classList.add('active');
      });
      // color previous td-s from current row
      const allTds = Array.from($event.target.closest('tr').querySelectorAll('td'));
      const previousTds = allTds.slice(0, allTds.findIndex((td) => td.classList.contains(`td-${tdIndex}`)));
      previousTds.forEach((td) => {
        td.classList.add('active');
      });
    },
    removeHover() {
      const hoveredEls = document.querySelectorAll('.active');
      hoveredEls.forEach((element) => {
        element.classList.remove('active');
      });
    },
    currentSelectedAlpha(selectedAlpha) {
      this.selectedAlpha = selectedAlpha;

      this.currentTable = { ...tables.fdTable };
      this.currentTable.values = this.currentTable.values[selectedAlpha];
    },
  },
};
</script>

<style lang="scss" scoped>
.tables-container {
  padding: var(--spacing-60) var(--spacing-50);
  background: var(--main-light);
  box-shadow: 0 3px 8px rgba(0, 12, 31, 0.05);
  border-radius: 10px;

  .head-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    .h3,
    h4 {
      text-align: center;
      color: var(--accent-shade-3);
    }

    h4,
    p {
      margin: 0;
    }

    .h3 {
      margin-bottom: var(--spacing-20);
    }

    .description {
      text-align: center;
      line-height: 150%;
      margin: var(--spacing-36) 0;

      &.fd-table {
        margin: var(--spacing-16) 0 var(--spacing-20);
      }
    }

    .dropdown-label {
      font-size: 14px;
    }

    .dropdown::v-deep {
      width: 150px;
      height: 52px;
      margin: var(--spacing-6) 0 var(--spacing-36);
      border: 1px solid rgba(0, 12, 31, 0.18);
      border-radius: 5px;
      background: var(--main-light);
      box-shadow: unset;

      &.open {
        border: 0.89px solid rgba(0, 12, 31, 0.48);
        border-bottom: 0;
        border-radius: 5px 5px 0 0;
      }

      .list-head {
        padding: var(--spacing-14) 0 var(--spacing-14) var(--spacing-12);
        font-weight: 400;
        font-size: 18px;
        line-height: 120%;
        color: var(--main-dark);
        max-width: unset;
      }

      span {
        color: var(--main-dark);
        font-weight: 400;
        font-size: 18px;
      }

      label.active {
        span {
          color: var(--accent);
        }
      }

      .radio:hover {
        background: var(--accent-light-2);
        box-shadow: 0 3px 8px rgba(0, 12, 31, 0.05);
      }
    }
  }

  .cl-info {
    margin-top: var(--spacing-40);
    font-size: 14px;
  }

  .wrapper {
    width: 100%;

    &.gradient {
      position: relative;

      &:after {
        content: "";
        width: 55px;
        position: absolute;
        height: 100%;
        right: 0;
        top: 0;
        background: linear-gradient(270deg, var(--main-light) 1.64%, rgba(255, 255, 255, 0) 84.62%);
      }

      &:before {
        content: "";
        width: 55px;
        position: absolute;
        height: 100%;
        left: 0;
        top: 0;
        background: linear-gradient(90deg, var(--main-light) 1.64%, rgba(255, 255, 255, 0) 84.62%);
      }
    }

    &.no-gradient-after {
      &:after {
        content: none;
      }
    }

    &.no-gradient-before {
      &:before {
        content: none;
      }
    }

    .table-wrapper {
      width: calc(100% + 4px);
      border-radius: 6px;
      overflow: hidden;

      &.std-table {
        border: 2px solid var(--accent-shade-3);
      }

      tr:first-child th:first-child { border-top-left-radius: 4px; }
      tr:first-child th:last-child { border-top-right-radius: 4px; }
      tr:last-child th:first-child { border-bottom-left-radius: 4px; }
      tr:last-child th:last-child { border-bottom-right-radius: 4px; }
      tr:last-child td:first-child { border-bottom-left-radius: 4px; }
      tr:last-child td:last-child { border-bottom-right-radius: 4px; }

      &.bigger-tables {
        display: flex;
        width: 100%;
        padding-bottom: var(--spacing-24);
        overflow-y: hidden;
        overflow-x: scroll;

        .bigger-tables-wrapper {
          border-radius: 6px;
          border: 2px solid var(--accent-shade-3);
        }

        &::-webkit-scrollbar {
          width: auto;
          height: 8px;
        }

        &::-webkit-scrollbar-track {
          background-color: var(--main-light);
        }

        &::-webkit-scrollbar-thumb {
          background: var(--main-light-shade-4);
          border-radius: 10px;
        }
      }

      th,
      td {
        border: 1px solid var(--accent-shade-3);
      }

      table {
        border-collapse: collapse;
        width: 100%;

        tr {
          height: 46px;
          display: flex;

          th,
          td {
            text-align: center;
            vertical-align: middle;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 118px;
            height: 46px;

            &.padding-right {
              padding-right: var(--spacing-30);
            }

            &:hover {
              background: var(--accent-light-3);
              cursor: pointer;
            }

            &.active {
              background: var(--accent-light-2);
            }
          }

          th {
            background: var(--accent-shade-1);
            color: var(--main-light);
            font-weight: 400;
          }

          th:nth-child(1),
          td:nth-child(1) {
            width: 80px;
            height: 46px;
          }
        }

        h4 {
          color: var(--accent-shade-3);
        }
      }
    }
  }
}

@include bp($bp-mobile) {
  .tables-container {
    padding: 45px 0;

    .head-container {
      padding: 0 var(--spacing-24);

      .h3 {
        font-size: 24px;
        margin-bottom: var(--spacing-12);
      }

      h4 {
        font-size: 21px;
      }

      .description.fd-table {
        margin: var(--spacing-28) 0 var(--spacing-40);
      }

      .dropdown::v-deep {
        width: 60%;
        margin-bottom: var(--spacing-40);
      }
    }

    .wrapper .table-wrapper {
      border-radius: unset;
      width: calc(100% - 4px);
      margin: 0 auto;

      tr:first-child th:first-child { border-top-left-radius: unset; }
      tr:first-child th:last-child { border-top-right-radius: unset; }
      tr:last-child th:first-child { border-bottom-left-radius: unset; }
      tr:last-child th:last-child { border-bottom-right-radius: unset; }
      tr:last-child td:first-child { border-bottom-left-radius: unset; }
      tr:last-child td:last-child { border-bottom-right-radius: unset; }

      &.bigger-tables {
        width: calc(100% - 4px);

        .bigger-tables-wrapper {
          border-radius: unset;
        }
      }

      &.std-table {
        table {
          tr {
            th,
            td {
              width: 17.4%;
            }

            th:nth-child(1),
            td:nth-child(1) {
              width: 13%;
            }
          }
        }
      }

      table {
        tr {
          height: 28px;

          th,
          td {
            height: 28px;
            font-size: 14px;

            &.padding-right {
              padding: 0;
            }
          }

          th:nth-child(1),
          td:nth-child(1) {
            height: 28px;
          }
        }
      }
    }

    .cl-info {
      text-align: center;
      font-size: 12px;
    }
  }
}

@include bp($bp-phone) {
  .tables-container {
    .head-container {
      .dropdown::v-deep {
        width: 100%;
      }
    }

    .wrapper .table-wrapper {
      width: 100%;

      &.bigger-tables {
        width: 100%;
      }

      table {
        tr {
          th,
          td {
            width: 66px;
            font-size: 12px;
          }

          th:nth-child(1),
          td:nth-child(1) {
            width: 45px;
          }
        }
      }
    }
  }
}
</style>
